import React from "react";

import { Subscribe } from "unstated";
import SrpContainer from "../../../Srp/containers/SrpContainer";
import Pagination from "./Pagination";
const PaginationContainer = () => (
  <Subscribe to={[SrpContainer]}>
    {({ state: { data, query, pageInViewport }, loadPage }) => (
      <Pagination
        currentPage={pageInViewport}
        totalPages={data.pages}
        loadedPages={Object.keys(data.spaces).map((i) => parseInt(i, 10))}
        query={query}
        loadPage={loadPage}
      />
    )}
  </Subscribe>
);

export default PaginationContainer;
